export enum WsConnectionState {
  disconnected = 'disconnected',
  connecting = 'connecting',
  connected = 'connected',
  error = 'error'
}

export enum WsSubscriptionState {
  unsubscribed = 'unsubscribed',
  subscribing = 'subscribing',
  subscribed = 'subscribed'
}

export enum WsSubscriptionEvent {
  publication = 'publication'
}

export type WsSubscriptionListener = (data) => void;

export type QueueChannel = {
  key: string;
  listeners: WsSubscriptionListener[];
  subscriptionToken: string;
};

export enum PubSubWsEvent {
  // удаление подписки на канал сообщений
  subscriptionRemove = 'subscriptionRemove'
}

export type PubSubWsEventSubscriptionRemoveData = {
  channel: string;
};
